module.exports = __webpack_public_path__ + "img/GNSS.2daa8406.png";